import styled from "@emotion/styled";

import { fontRobotoCondensed, theme, transientOptions } from "shared/lib/styles";
import type { WithStickyStackedHeightProps } from "shared/lib/styles";

import { Flag } from "scmp-app/components/common/loading/wheel-icon/styles";
import { H1Container, H2Container } from "scmp-app/components/content/content-headline/styles";
import {
  Headline,
  StyledEntityLink,
  Summary,
} from "scmp-app/components/content/content-item-render/variants/search/styles";
import { Search } from "scmp-app/components/search";
import {
  Headline as SearchExploreKeyAnglesEntryHeadline,
  StyledEntityLink as SearchExploreKeyAnglesEntryHeadlineLink,
} from "scmp-app/components/search/search-explore-key-angles/item/entry/styles";
import { StyledTopic } from "scmp-app/components/search/search-explore-topics/search-explore-topics-list/styles";
import { Container as SearchExploreTopicsContainer } from "scmp-app/components/search/search-explore-topics/styles";
import {
  Headline as SearchFollowTheTimelineEntryHeadline,
  StyledEntityLink as SearchFollowTheTimelineEntryHeadlineLink,
} from "scmp-app/components/search/search-follow-the-timeline/item/entry/styles";
import {
  ClearFade,
  LeadingMagnifier,
  SearchButton,
  StyledInput,
} from "scmp-app/components/search/search-input/styles";
import { FieldLabel as SectionFieldLabel } from "scmp-app/components/search/search-result-panel/refine-search/section-field/styles";
import { FieldLabel as SortByFieldLabel } from "scmp-app/components/search/search-result-panel/refine-search/sort-by-toggle/styles";
import { Header as RefineSearchPanelHeader } from "scmp-app/components/search/search-result-panel/refine-search/styles";
import { FieldLabel as TimeRangeFieldLabel } from "scmp-app/components/search/search-result-panel/refine-search/time-range-field/styles";
import { FieldLabel as TypeFieldLabel } from "scmp-app/components/search/search-result-panel/refine-search/type-field/styles";
import {
  Container as TopicsCardContainer,
  Title as TopicsCardTitle,
  Toggle as TopicsCardToggle,
} from "scmp-app/components/search/search-result-panel/result-list/topics-card/styles";
import { StyledRefineSearchPanel, StyledSearchInput } from "scmp-app/components/search/styles";

export const StyledSearch = styled(Search, {
  ...transientOptions,
})<WithStickyStackedHeightProps>`
  ${theme.breakpoints.only("mobile")} {
    display: none;
  }

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 24px;
  }

  ${LeadingMagnifier} path {
    fill: #001246;
  }

  ${StyledSearchInput}, ${StyledInput} {
    background-color: #f7f6ef;
  }

  ${StyledSearchInput} {
    inset-block-start: ${props => props.$stickyStackedHeight - 20 + "px"};
  }

  ${SearchButton} {
    background-color: #556bb4;
  }

  ${ClearFade} {
    background: linear-gradient(to right, rgba(247, 246, 239, 0), #f7f6ef);
  }

  ${Flag} {
    &::before,
    &::after {
      background-color: #f7f6ef;
    }
  }

  ${StyledRefineSearchPanel}, ${TopicsCardContainer} {
    border: 1px solid #dfdfdf;

    background-color: #ecebe3;
  }

  ${RefineSearchPanelHeader}, ${TopicsCardTitle} {
    border-block-end: 1px #727272 solid;
  }

  ${TopicsCardToggle} {
    color: #001246;
  }

  ${SearchExploreTopicsContainer} {
    background-color: #ecebe3;
  }

  ${StyledTopic} {
    ${theme.breakpoints.up("tablet")} {
      &:not(:last-of-type) {
        border-block-end: 1px solid #cccccc;
      }
    }
  }

  ${TimeRangeFieldLabel}, ${SectionFieldLabel}, ${SortByFieldLabel}, ${TypeFieldLabel} {
    color: #000000;
  }

  ${Headline} {
    ${H1Container}, ${H2Container} {
      font-family: ${fontRobotoCondensed};

      ${theme.breakpoints.up("tablet")} {
        font-size: 20px;
      }
    }
  }

  ${Summary} {
    ${StyledEntityLink} {
      max-block-size: 67.5px;

      font-size: 16px;
      font-family: ${fontRobotoCondensed};
    }
  }

  ${SearchExploreKeyAnglesEntryHeadline} {
    ${SearchExploreKeyAnglesEntryHeadlineLink} {
      font-size: 16px;
      font-family: ${fontRobotoCondensed};
    }
  }

  ${SearchFollowTheTimelineEntryHeadline} {
    ${SearchFollowTheTimelineEntryHeadlineLink} {
      font-size: 15px;
      font-family: ${fontRobotoCondensed};
    }
  }
`;
